export default __webpack_public_path__ + "static/70-0cf5e1e86003cd7f0717a4afb07e8050.jpg";